import React from 'react'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'

import Notifier from '@softwaredev_cegeka/stix-notifier/dist/components/Notifier'

// Routes
import Main from './routes/Main'
import withAuth from 'src/components/auth/withAuth'
import Unauthorized from './routes/Unauthorized'

class App extends React.Component {
    render() {
        const MainContent = withAuth(Main)

        return (
            <Router history={this.props.history}>
                <Switch>
                    <Route
                        exact
                        path={'/unauthorized'}
                        component={Unauthorized}
                    />
                    <Notifier>
                        <MainContent />
                    </Notifier>
                </Switch>
            </Router>
        )
    }
}

export default App
